import { nextTick } from "vue";
import { cloneDeep } from "@/shared/utils/helpers";
import { projectsService } from "@/shared/projects/projects.service";
import { coffeeSnapshotService } from "@/apps/coffee/store/coffee-snapshot.service";
import { prepareCoffee } from "@/shared/projects/prepareData.js";

export default {
    namespaced: true,
    actions: {
        async saveSnapshot({ rootState, dispatch }) {
            rootState.waiting = true;
            const coffeeState = rootState.coffee;
            try {
                await coffeeSnapshotService.updateSnapshotAfterSave(coffeeState.coffee.uuid, {
                    stateSlice: coffeeState,
                    actionToTakeIfNotRequired: () => dispatch("mergeSnapshotChanges"),
                });
                rootState.waiting = false;
            } catch {
                /* eslint-disable-next-line no-empty */
            }
        },
        async mergeSnapshotChanges({ rootState, commit }) {
            await nextTick();

            rootState.waiting = true;

            const coffee = cloneDeep(rootState.coffee.coffee);
            delete coffee.id;
            delete coffee.createdAt;
            delete coffee.updatedAt;
            delete coffee.publishedAt;
            delete coffee.uuid;

            try {
                const project = await projectsService.update({
                    tool: "coffee",
                    uuid: rootState.coffee.coffee.uuid,
                    data: coffee,
                });

                rootState.coffee.hasSnapshot = false;

                commit("showNotify", "autoSave", { root: true });

                await nextTick();
                const updatedCoffee = prepareCoffee(project);

                commit(
                    "coffee/setProject",
                    {
                        coffee: updatedCoffee,
                        snapshot: {},
                    },
                    { root: true }
                );
            } catch {
                /* eslint-disable-next-line no-empty */
            } finally {
                rootState.waiting = false;
            }
        },
        async loadProject({ rootState, commit }, uuid) {
            rootState.waiting = true;
            try {
                const { project, snapshot } = await projectsService.getOneWithSnapshot({
                    tool: "coffee",
                    uuid,
                });
                const coffee = prepareCoffee(project);
                commit(
                    "coffee/setProject",
                    {
                        coffee,
                        snapshot,
                    },
                    { root: true }
                );
                rootState.waiting = false;
            } catch {
                /* eslint-disable-next-line no-empty */
            }
        },
    },
};
